import { useQuery } from "react-query";

import { ApiResult } from "../api/apiResult";
import { fetchOriginalPlayTo3DDataSources } from "../api/ipdp";

export const ORIGINAL_PLAY_TO_3D_DATA_SOURCES_QUERY_KEY =
  "fetchOriginalPlayTo3DDataSources";

///hook to fetch ipdb fields
export default function useOriginalPlayTo3DDataSources(): ApiResult<string[]> {
  const { data, isLoading, isError, refetch } = useQuery<string[]>(
    ORIGINAL_PLAY_TO_3D_DATA_SOURCES_QUERY_KEY,
    fetchOriginalPlayTo3DDataSources,
    {
      enabled: false
    }
  );

  return {
    data,
    isLoading,
    isError,
    refetch
  };
}
